import { render } from "./DraggableModal.vue?vue&type=template&id=193262c9&scoped=true"
import script from "./DraggableModal.vue?vue&type=script&lang=js"
export * from "./DraggableModal.vue?vue&type=script&lang=js"

import "./DraggableModal.vue?vue&type=style&index=0&id=193262c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193262c9"]])

export default __exports__